import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const path = '../oldPages/transfer-statements/statements/index.html';

const links: Record<string, string> = {
  search: '/infoTrac/transfer-statements/account-statements-pop-up',
};

function AccountStatements() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleIframeLoad = () => {
      const iframeDocument = iframeRef.current?.contentDocument || iframeRef.current?.contentWindow?.document;

      if (!iframeDocument) return;

      const openModal = iframeDocument.getElementsByClassName('emailStatement');
      const closeModal = iframeDocument.getElementsByClassName('closeModal');

      const search = iframeDocument.getElementsByClassName('searchBtn');

      if (openModal.length) {
        for (let i = 0; i < openModal.length; i++) {
          openModal[i].addEventListener('click', () => {
            document.body.classList.add('lightbox-open');
          });
        }
      }

      if (closeModal.length) {
        for (let i = 0; i < closeModal.length; i++) {
          closeModal[i].addEventListener('click', () => {
            document.body.classList.remove('lightbox-open');
          });
        }
      }

      if (search.length) {
        for (let i = 0; i < search.length; i++) {
          search[i].addEventListener('click', () => navigate(links.search));
        }
      }
    };

    if (iframeRef.current) iframeRef.current.addEventListener('load', handleIframeLoad);

    return () => {
      if (iframeRef.current) iframeRef.current.removeEventListener('load', handleIframeLoad);
    };
  }, []);

  return (
    <iframe
      ref={iframeRef}
      title="transfer-statements-account-statements"
      src={path}
      className="z-[100] relative"
      width="100%"
      height="800px"
    />
  );
}

export default AccountStatements;
